import axios, { AxiosInstance, AxiosResponse, AxiosError, InternalAxiosRequestConfig } from 'axios'

import { ADMIN_PUBLIC_API_URL } from '@/config/constants'

// 工具管理 API 配置
interface ToolsApiConfig {
  baseURL?: string
  timeout?: number
}

/**
 * 工具管理 API 客户端
 * 用于请求部署在 Vercel 上的工具配置管理接口
 */
class AdminApiClient {
  private instance: AxiosInstance

  constructor(config?: ToolsApiConfig) {
    this.instance = axios.create({
      baseURL: ADMIN_PUBLIC_API_URL,
      timeout: config?.timeout || 60 * 1000,
      headers: {
        'Content-Type': 'application/json'
        // 'x-vercel-protection-bypass': 'CuZYQoTAwaH7cIIRpsAZEAOG3y6VnhLR'
      },
      ...config
    })

    this.initializeInterceptors()
  }

  private initializeInterceptors(): void {
    // 响应拦截器
    this.instance.interceptors.response.use(
      (response: AxiosResponse) => {
        // 根据你管理端的响应格式调整
        // 如果管理端返回 { success: true, data: ... } 格式
        if (response.data?.data !== undefined) {
          return response.data.data
        }
        return response.data
      },
      (error: AxiosError) => {
        console.error('Tools API Error:', error.response?.data || error.message)
        return Promise.reject(error)
      }
    )
  }

  public get<T = any>(url: string, config?: Partial<InternalAxiosRequestConfig>): Promise<T> {
    return this.instance.get(url, config) as Promise<T>
  }

  public post<T = any>(url: string, data?: any, config?: InternalAxiosRequestConfig): Promise<T> {
    return this.instance.post(url, data, config) as Promise<T>
  }
}

// 导出单例
export const adminApiClient = new AdminApiClient()
